import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase.js'
import { getBadgeBySlug } from '../lib/badges.js'

/**
 * Listens for new participant_badges rows and surfaces any that haven't been
 * shown to the user yet. Once shown, the caller marks them seen via markSeen().
 */
export function useBadgeUnlocks(participantId) {
  const [pending, setPending] = useState([])

  useEffect(() => {
    if (!supabase || !participantId) return
    let cancelled = false

    async function reload() {
      const { data } = await supabase
        .from('participant_badges')
        .select('id, awarded_at, seen_by_user, badges(slug, name, description, icon_url)')
        .eq('participant_id', participantId)
        .eq('seen_by_user', false)
        .order('awarded_at', { ascending: true })
      if (cancelled) return
      const enriched = (data || []).map(row => {
        const def = getBadgeBySlug(row.badges?.slug)
        return {
          id: row.id,
          slug: row.badges?.slug,
          name: row.badges?.name || def?.name,
          description: row.badges?.description || def?.description,
          emoji: def?.emoji,
        }
      })
      setPending(enriched)
    }

    reload()
    const channel = supabase
      .channel(`badges-${participantId}-${Math.random().toString(36).slice(2, 10)}`)
      .on('postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'participant_badges', filter: `participant_id=eq.${participantId}` },
        reload)
      .subscribe()

    return () => {
      cancelled = true
      supabase.removeChannel(channel)
    }
  }, [participantId])

  async function markSeen(id) {
    setPending(prev => prev.filter(b => b.id !== id))
    if (!supabase) return
    await supabase.from('participant_badges').update({ seen_by_user: true }).eq('id', id)
  }

  return { pending, markSeen }
}
